export default __webpack_public_path__ + "static/security-3-ab01b898a68a2affbe1b02428a8531ed.png";